<template>
  <div class="ptsonthrss">
  <div class="btn-tan-three">
       
            <!-- 右边轮播显示 -->
            <div class="btn-tan-right-video">

                <div class="pc-slide">
                    <div class="view">
                        <!-- 大图按钮 -->
                        <a class="arrow-left" href="#"></a>
                        <a class="arrow-right" href="#"></a>
                        <div class="swiper-container">

                            <div  class="swiper-wrapper">
                                <div v-for="(item,index) in ptsontwoimgs" :key="item.id" class="swiper-slide">
                                   <img class="pptimgone" :src="'http://ke.yunlearning.com:8081'+ptsontwoimgs[index]" alt="">
                                </div>
                               

                            </div>
                        </div>
                    </div>
                    <div class="preview">
                        <a class="arrow-left" href="#"></a>
                        <a class="arrow-right" href="#"></a>
                        <div class="swiper-container">
                            <div class="swiper-wrapper">
                                <div v-for="(item,index) in ptsontwoimgs" :key="item.id" class="swiper-slide active-nav">
                                    <img class="pptimgtwo" :src="'http://ke.yunlearning.com:8081'+ptsontwoimgs[index]" alt="">
                                </div>
                             
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
  </div>
</template>

<script>
import $ from 'jquery'
import Swiper from '../../node_modules/swiper/js/swiper'
import axios from 'axios'
export default {
    data(){
        return{
           ptsontwoimgs:[]
        }
    },
    
     methods:{

     
     },
    
 beforeMount(){
this.ptsontwoimgs = JSON.parse(sessionStorage.getItem('pptUrl'));
 },
mounted(){


// console.log(this.ptsontwoimgs);
//  轮播图方法
   var viewSwiper = new Swiper('.view .swiper-container', {
        onSlideChangeStart: function() {
            updateNavPosition();
        }
    })

    $('.view .arrow-left,.preview .arrow-left').on('click', function(e) {
        e.preventDefault();
        if (viewSwiper.activeIndex == 0) {
            viewSwiper.swipeTo(viewSwiper.slides.length - 1, 1000);
            return;
        }
        viewSwiper.swipePrev();
    })
    $('.view .arrow-right,.preview .arrow-right').on('click', function(e) {
        e.preventDefault();
        if (viewSwiper.activeIndex == viewSwiper.slides.length - 1) {
            viewSwiper.swipeTo(0, 1000);
            return
        }
        viewSwiper.swipeNext();
    })

    var previewSwiper = new Swiper('.preview .swiper-container', {
        visibilityFullFit: true,
        slidesPerView: 'auto',
        onlyExternal: true,
        onSlideClick: function() {
            viewSwiper.swipeTo(previewSwiper.clickedSlideIndex);
        }
    })

    function updateNavPosition() {
        $('.preview .active-nav').removeClass('active-nav');
        var activeNav = $('.preview .swiper-slide').eq(viewSwiper.activeIndex).addClass('active-nav');
        if (!activeNav.hasClass('swiper-slide-visible')) {
            if (activeNav.index() > previewSwiper.activeIndex) {
                var thumbsPerNav = Math.floor(previewSwiper.width / activeNav.width()) - 1;
                previewSwiper.swipeTo(activeNav.index() - thumbsPerNav);
            } else {
                previewSwiper.swipeTo(activeNav.index());
            }
        }
    }
 
    
}


}
</script>

<style>
@import '../css/swiper.css';
.ptsonthrss{
     width: 9.91rem;
     height: 6.13rem;
     float: left;
      margin-left: 0.03rem;
}
 .btn-tan-three {
     width: 9.91rem;
     height: 6.13rem;
     overflow: hidden;
     position: relative;
}
/* 右侧轮播 */
 .btn-tan-right-video {
     width: 9.91rem;
     height: 6.13rem;
     background-color: #383842;
     border-radius: 0rem 0.05rem 0.05rem 0rem;
     float: right;
     position: relative;
}
 .pc-slide {
     margin: 0.15rem auto;
}
 .view .swiper-container,.pptimgone{
     width: 8.91rem;
     height: 4.8rem;
}
 .view .arrow-left {
     background: url('../images/index_tab_l.png') no-repeat;
     position: absolute;
     left: 0.1rem;
     top: 40%;
     width: 0.28rem;
     height: 0.51rem;
     z-index: 10;
     background-size: 100% 100%;
}
 .view .arrow-right {
     background: url('../images/index_tab_r.png') no-repeat;
     position: absolute;
     right: 0.05rem;
     top: 40%;
     width: 0.28rem;
     height: 0.51rem;
      background-size: 100% 100%;
}
/* 下部缩略图 */
 .preview {
     width: 100%;
     margin-top: 0.1rem;
     position: relative;
}
 .preview .swiper-container {
     width: 8.91rem;
     height: 1rem;
     position: absolute;
     left: 0.45rem;
}
 .preview .swiper-slide,.pptimgtwo {
     width: 1.6rem;
     height: 0.9rem;
     padding-left: 0.19rem;
}
 .large {
     margin-left: 0.4rem;
}
 .preview .slide6 {
     width: 1.46rem;
}
 .preview .arrow-left {
     width: 0.37rem;
     height: 0.81rem;
     background: url('../images//feel3.png') no-repeat left top;
     position: absolute;
     left: 0.1rem;
     top: 50%;
     z-index: 10;
      background-size: 100% 100%;
}
 .preview .arrow-right {
     background: url('../images/feel4.png') no-repeat left bottom;
     position: absolute;
     right: 0.05rem;
     top: 50%;
     width: 0.37rem;
     height: 0.81rem;
      background-size: 100% 100%;
}
 .preview img {
     padding: 0.03rem;
}
 .preview .active-nav img {
     border: 3px solid #0265BB;
     padding: 0rem;
}
 
</style>


// WEBPACK FOOTER //
// src/components/PtSonthree.vue